import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=48675a75&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionJournalTopWithImage: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionJournalTopWithImage/index.vue').default,SectionJournalTop: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionJournalTop/index.vue').default,ArticleSection: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ArticleSection/index.vue').default,Section: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Section/index.vue').default,SectionAviaKassaWidgetComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionAviaKassaWidgetComponent/index.vue').default,SharingComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SharingComponent/index.vue').default,SectionComments: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionComments/index.vue').default,SectionBannerAppMobile: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionBannerAppMobile/index.vue').default,SectionBillboard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SectionBillboard/index.vue').default})
